import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SlideOver } from "@/components/ui/slide-over";
import { Notify } from "@/components/ui/notify";
import { useLineCalendar } from "./hooks";
import { CalendarSheetBody } from "./CalendarSheetBody";

interface Props {
  lineId: string;
}

// Ponto de entrada do editor de expediente no LineEditorUnified: botão que abre um
// SlideOver com os turnos + exceções. O corpo remonta a cada abertura (key) p/ re-semear o rascunho.
export function LineCalendarEditor({ lineId }: Props) {
  const [open, setOpen] = useState(false);
  const query = useLineCalendar(lineId);
  const hasCalendar = (query.data?.weeklyShifts.length ?? 0) > 0;

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)}>
        <CalendarClock className="mr-1.5 h-4 w-4" />
        {hasCalendar ? "Expediente" : "Definir expediente"}
      </Button>

      <SlideOver open={open} onOpenChange={setOpen} title="Expediente da linha" width={560}>
        {query.isLoading ? (
          <p className="p-4 text-sm text-text-secondary">Carregando expediente…</p>
        ) : query.isError ? (
          <div className="p-4">
            <Notify.QueryError
              error={query.error}
              onRetry={() => void query.refetch()}
              title="Não foi possível carregar o expediente"
            />
          </div>
        ) : (
          <CalendarSheetBody
            key={open ? "open" : "closed"}
            lineId={lineId}
            initial={query.data ?? null}
            onDone={() => setOpen(false)}
          />
        )}
      </SlideOver>
    </>
  );
}
